module.exports = __webpack_public_path__ + "img/kyed-back.521d4532.png";